<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-date-picker
            v-model="time"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>&nbsp;&nbsp;|
          <el-button type="primary" @click="excelData" plain>导出</el-button>
          <el-button circle @click="qieFun"><el-image :src="qiehuanIcon" style="width: 20px;height: 20px;vertical-align: middle;"></el-image></el-button>
          <div style="float: right;">
            <el-button :type="checkButtom1" @click="qie(1)" icon="el-icon-s-unfold" plain>表格</el-button>
            <!--<el-button :type="checkButtom2" @click="qie(2)" icon="el-icon-s-data" plain>图形</el-button>-->
          </div>
        </div>

      </el-header>
      <el-main :style="tableBlock">
        <template>
          <el-table
            :data="tableData"
            show-summary
            :summary-method="getSummaries"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="customerName"
              label="名称"
              width="150">
            </el-table-column>
            <!--<el-table-column
              prop="class"
              label="客户分类"
              width="120">
            </el-table-column>-->
            <el-table-column
              prop="goodsNumber"
              sortable
              :formatter="formatterAmount"
              label="新增商品数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="addedNumber"
              sortable
              :formatter="formatterAmount"
              label="新增采购商数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="orderNumber"
              sortable
              :formatter="formatterAmount"
              label="订单总数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="orderSales"
              sortable
              :sort-method="(a, b)=>{return a.orderSales - b.orderSales }"
              :formatter="formatterAmount"
              label="订单销售额"
              width="150">
            </el-table-column>
            <el-table-column
              sortable
              label="客单价"
              width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.placeNumber > 0 ? (parseFloat(scope.row.orderSales) / parseFloat(scope.row.placeNumber)).toFixed(2) : 0 }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="orderDeal"
              sortable
              :sort-method="(a, b)=>{return a.orderDeal - b.orderDeal }"
              :formatter="formatterAmount"
              label="订单总成交额"
              width="150">
            </el-table-column>
            <el-table-column
              prop="placeNumber"
              sortable
              :formatter="formatterAmount"
              label="下单采购商数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="ipNumber"
              sortable
              :formatter="formatterAmount"
              label="访问量"
              width="150">
            </el-table-column>
            <el-table-column
              sortable
              label="转化率"
              width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.ipNumber > 0 ? parseFloat((parseFloat(scope.row.placeNumber) / parseFloat(scope.row.ipNumber)) * 100).toFixed(2) : 0}}{{'%'}}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="verifySMSNumber"
              sortable
              label="验证短信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="marketingSMSNumber"
              sortable
              label="营销短信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="marketingMMSNumber"
              sortable
              label="营销彩信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="xcxOrderNumber"
              sortable
              label="小程序订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="wxOrderNumber"
              sortable
              label="微信商城订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="appOrderNumber"
              sortable
              label="APP订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="pcOrderNumber"
              sortable
              label="PC订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="identification"
              label="标识"
              width="80">
            </el-table-column>
            <el-table-column
              prop="dataTime"
              fixed="right"
              label="统计时间"
              width="200">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-main :style="graphicalBlock" v-cloak>
        <div style="width: 100%;">
          <div id="myChart_all" :style="myChartdivHeight">
          </div>
          <div id="myChart_bottom" :style="myChartdivHeight">
          </div>
        </div>
      </el-main>
      <el-footer :style="tableBlock">
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import PurplePassion from '@/assets/purplePassion.js'
  export default {
    data () {
      return {
        qiehuanIcon: require('@/assets/qiehuan.png'),
        numtype: 'NUM',
        serchat:"",
        time:"",
        dropdownTitle:"请选择",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        myChartdivHeight:{
          width: '100%', height: '315px',float:'left'
        },
        dropdownList:[],
        checkButtom1:"primary",
        checkButtom2:"info",
        tableBlock:{
          display:'block'
        },
        graphicalBlock:{
          display:'block'
        },
        myChart_all:null,
        myChart_bottom:null,
        orderNumber:[],
        orderSales:[],
        orderDeal:[],
        placeNumber:[],
        ipNumber:[],
        addedNumber:[],
        dataTime:[],
        gDataList:[],
        checkNum:1
      }
    },
    methods:{
      formatterAmount(row, column, cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            if (parseFloat(cellValue) > 9999) {
              const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
              let num = Math.abs(cellValue);
              const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
              const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
              return result;
            } else {
              return parseFloat(cellValue).toFixed(2)
            }
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatterAmount1(cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
            let num = Math.abs(cellValue);
            const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
            const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
            return cellValue <= 0 ? 0 : result;
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy年MM月dd日";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      qie(val){
        if(val == 1){
          this.checkButtom1 = "primary";
          this.checkButtom2 = "info";
          this.graphicalBlock.display = 'none';
          this.tableBlock.display = 'block';
        }else{
          this.checkButtom2 = "primary";
          this.checkButtom1 = "info";
          this.tableBlock.display = 'none';
          this.graphicalBlock.display = 'block';
        }
        this.checkNum = val;
      },
      showGraphical(){
        this.orderNumber = [];
        this.orderSales = [];
        this.orderDeal = [];
        this.placeNumber = [];
        this.ipNumber = [];
        this.addedNumber = [];
        this.dataTime = [];

        for(var i=0;i<this.gDataList.length;i++){
          this.orderNumber.push(this.gDataList[i].orderNumber)
          this.placeNumber.push(this.gDataList[i].placeNumber)
          this.ipNumber.push(this.gDataList[i].ipNumber)
          this.addedNumber.push(this.gDataList[i].addedNumber)
          var _a_ = parseFloat(this.gDataList[i].orderSales).toFixed(2);
          this.orderSales.push(parseFloat(_a_))
          var _b_ = parseFloat(this.gDataList[i].orderDeal).toFixed(2);
          this.orderDeal.push(parseFloat(_b_))
          this.dataTime.push(this.gDataList[i]._id)
        }
        var data1 = [
          {
            name: '订单总金额',
            type: 'line',
            label: "订单总金额",
            data: this.orderSales,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '订单总成交额',
            type: 'bar',
            label: "订单总成交额",
            data: this.orderDeal,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          }
        ]
        var data2 = [
          {
            name: '新增采购商数量',
            type: 'bar',
            barGap: 0,
            label: "新增采购商数量",
            data: this.addedNumber,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '订单总数量',
            type: 'line',
            label: "订单总数量",
            data: this.orderNumber,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '下单客户数',
            type: 'bar',
            label: "下单客户数",
            data: this.placeNumber,
            markPoint : {
              data : [
                {type : 'max', name: '最大值',color:'red'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '访问量',
            type: 'line',
            label: "访问量",
            data: this.ipNumber,
            markPoint : {
              data : [
                {type : 'max', name: '最大值',color:'red'},
                {type : 'min', name: '最小值'}
              ]
            }
          }
        ]
        this.myChart_all.hideLoading();
        this.myChart_all.setOption(this.dataLine(data1,this.dataTime,['订单总金额','订单总成交额']),true);
        this.myChart_bottom.hideLoading();
        this.myChart_bottom.setOption(this.dataLine(data2,this.dataTime,['新增采购商数量', '订单总数量', '下单客户数','访问量']),true);
        this.myChartdivHeight.height = (window.innerHeight-18)/2+"px";
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      excelData:async function () {
        await this.$axios.post('/data/excelDayData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            location.href = response.data;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      dataLine(data,xdata,ldata){
        return {
          color: ['#87F7CF', '#FF4046', '#FC97AF', '#008000'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ldata
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          calculable: true,
          grid:{
            top:"50px",
            left:"50px",
            right:"15px",
            bottom:"50px"
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: xdata,
            }
          ],
          grid:{
            x: 90, //默认是80px
            y: 60, //默认是60px
            x2: 40, //默认80px
            y2: 60 //默认60px
          },
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: function (value) {
                  value = value/10000;
                  return value+"万";
                }
              }
            }
          ],
          series: data
        }
      },
      qieFun: function () {
        this.$store.commit('setStoreNumtype', this.$store.getters.getStoreNumtype === 'NUM' ? 'CN' : 'NUM');
        this.isAjax()
      },
      isAjax:async function(){
        await this.$axios.post('/data/addDayData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time,
          "count":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            // this.gDataList = response.data[2];
            this.divHeight = window.innerHeight-108;
            if(this.checkNum == 1){
              this.graphicalBlock.display = 'none';
            }
            this.$nextTick (function () {
              this.showGraphical();
            })
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
          if (index === 9 || index === 5 || index === 17 || index === 18 ) {
            sums[index] = 'N/A';
          }else {
            if (sums[index] && sums[index] !== 'N/A') {
              sums[index] = parseFloat(sums[index]).toFixed(2);
              sums[index] = this.formatterAmount1(sums[index])
            } else {
              sums[index] = 0
            }
          }
        });
        return sums;
      }
    },
    mounted(){
      this.$store.dispatch('loadData');
      this.addClass();
      this.$echarts.registerTheme('purple-passion', PurplePassion)
      this.myChart_all = this.$echarts.init(document.getElementById('myChart_all'),'purple-passion')
      this.myChart_bottom = this.$echarts.init(document.getElementById('myChart_bottom'),'purple-passion')
      this.isAjax();
    }
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/dayData.vue